<template>
  <div>
    <hr>
    <el-form v-if="fields" size="small" label-position="left" label-width="120px">
      <el-form-item label="Action">
        <el-select 
          @change="handleActionChange"
          style="width: 100%"
          v-model="action.key"
          placeholder="Please select an action">
          <el-option 
            v-if="item in fields"
            v-for="(item, key) in eventActions" 
            :key="key" 
            :label="fields[item].title" 
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :key="key" v-for="(inputField, key) in inputFields">
        <el-input :type="inputField.type" :placeholder="inputField.title" v-model="action.data[inputFieldsKeys[key]]" />
      </el-form-item>
      <el-form-item>
        <el-select 
          style="width: 100%"
          v-model="action.execution_option"
          placeholder="Please select an execution option">
          <el-option 
            v-for="(option, key) in executionOptions" 
            :key="key" 
            :label="option.label" 
            :value="option.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-if="action.execution_option == 1">
        <el-select 
          style="width: 100%"
          v-model="action.execute_day"
          placeholder="Please select an execution day">
          <el-option 
            v-for="(option, key) in executionTimeOptions" 
            :key="key" 
            :label="option[1]" 
            :value="option[0]">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-if="action.execution_option == 1">
        <el-time-picker
          @change="handleTimeChange"
          v-model="action.execute_time"
          placeholder="Please select an execution time">
        </el-time-picker>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'RuleAction',
  computed: {
    inputFields() {
      if (!this.action.key) return null;
      return Object.values(this.fields[this.action.key].fields);
    },
    inputFieldsKeys() {
      if (!this.action.key) return null;
      return Object.keys(this.fields[this.action.key].fields);
    },
  },
  data: () => ({
    executionOptions: [
      { label: 'Immediately', value: 0 },
      { label: 'At a predefined time', value: 1 },
    ],
    executionTimeOptions: [
      ['anydays', 'On any day'],
      ['weekdays', 'On a weekday'],
      ['weekends', 'On a weekend'],
      ['mondays', 'On a Monday'],
      ['tuesdays', 'On a Tuesday'],
      ['wednesdays', 'On a Wednesday'],
      ['thursdays', 'On a Thursday'],
      ['fridays', 'On a Friday'],
      ['saturdays', 'On a Saturday'],
      ['sundays', 'On a Sunday'],
    ],
  }),
  props: {
    action: {
      type: Object,
      default: {},
    },
    fields: {
      type: Object,
      required: true,
    },
    actionKey: {
      type: String,
      default: '',
    },
    eventActions: {
      type: Array,
      default: [],
    },
  },
  methods: {
    handleTimeChange(time) {
      const day = this.action.execute_day;
      this.action.execution_data = `${day} ${time.getHours()}:${time.getMinutes()}`;
      this.action.execute_time_valid = true;
    },
    handleActionChange(action) {
      this.action.fields = this.fields[action].fields;
    },
  },
};
</script>



// WEBPACK FOOTER //
// RuleAction.vue?c1736b64